import styled from 'styled-components';

const ChipWrapper = styled.div.withConfig({
    displayName: "styles__ChipWrapper",
    componentId: "sc-12469cf4-0"
})`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    height: 18px;
    min-width: 24px;
    background-color: ${({ theme , $background  })=>$background || theme.colors.Color1};
    border-radius: 24px;
    box-sizing: border-box;
`;
const ChipText = styled.span.withConfig({
    displayName: "styles__ChipText",
    componentId: "sc-12469cf4-1"
})`
    ${({ theme  })=>theme.typography.SmallCapsHeadline};
    font-size: 8.5px;
    line-height: 10px;
    color: #ffffff;
`;
const ChipIcon = styled.div.withConfig({
    displayName: "styles__ChipIcon",
    componentId: "sc-12469cf4-2"
})`
    max-height: 18px;
    overflow: hidden;
    margin-right: 2px;
`;

export { ChipIcon, ChipText, ChipWrapper };
